import React from "react";
import "./Sura.css";
import quranBg from "../../assets/img/quran.jpg";
import colorBg from "../../assets/img/color-bg.jpg";
import sura1 from "../../assets/audio/surah-alfalaq.mp3";
import sura2 from "../../assets/audio/surah-kausar.mp3";
import { Carousel } from "react-bootstrap";

const Sura = () => {
  return (
    <div id="sura" className="container-fluid p-0">
      <section
        className="listen-holy"
        style={{
          backgroundImage: `url(${quranBg})`,
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <div className="heading two">
                <div className="ms-4">
                  <p>Listen Holy Quran</p>
                  <h3>Recite & Listen the Holy Quran Online</h3>
                </div>
                <Carousel>
                  <Carousel.Item>
                    <div>
                      <div className="wrapper">
                        <h4>Surah Falaq</h4>
                        <h5>(Abd-ur-Rahman)</h5>
                        <audio preload="auto" controls>
                          <source src={sura1} />
                        </audio>
                      </div>
                    </div>
                  </Carousel.Item>
                  <Carousel.Item>
                    <div>
                      <div className="wrapper">
                        <h4>Surah Kausar</h4>
                        <h5>(Abd-ur-Rahman)</h5>
                        <audio preload="auto" controls>
                          <source src={sura2} />
                        </audio>
                      </div>
                    </div>
                  </Carousel.Item>
                </Carousel>
              </div>
            </div>
            <div className="col-lg-4">
              <div
                className="support-us"
                sstyle={{
                  backgroundImage: `url(${colorBg})`,
                }}
              >
                <a href="#" className="btn">
                  Donate Now
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Sura;
